




























import { Component, Vue } from "@/shared/vuepack";
import MessageDetail from "../messageCenter/MessageDetail.vue";
import { useMessageCenterStore } from "@/employee/store/messageCenter";
import moment from "moment";
import { Watch } from "vue-property-decorator";
import { FetchState } from "@/shared/types";

@Component({
  components: {MessageDetail}
})
export default class MessageCenter extends Vue {

  messageCenterStore = useMessageCenterStore();
  selectedMessage = null;
  openDetail = false;

  mounted () {
    this.messageCenterStore.getMessages();
  }

  formatDate (date: string) {
    return moment(date).format("MM/DD/yyyy hh:mm A");
  }

  selectEmail (id: any) {
    if (this.openDetail) {
      this.openDetail = false;
      this.selectedMessage = null;
    }
    this.messageCenterStore.getSelectedMessage(id);
    this.openDetail = true;
  }

  @Watch("messageCenterStore.selectedMessage", { deep: true })
  setSelectedEmail () {
    if (this.messageCenterStore.messageFetchState === FetchState.Loaded) {
      this.selectedMessage = this.messageCenterStore.selectedMessage;
    }
  }


  onDetailClose () {
    this.openDetail = false;
  }

}
